import React from "react"
import TemperatureHumidityChart from "../DevServices/TemperatureHumidityChart"

const Charts = (props) => {
  const {selectedDev} = props
  //console.log(selectedDev)
  if (typeof(selectedDev.requestData.sensors_card_data) === 'undefined') return <></>
  const sensors_card_data = selectedDev.requestData.sensors_card_data
  //console.log(sensors_card_data)

/*   sensors_card_data.map((v,i) => {
    console.log(v.data_for_graph_today)
  }) */
  
  const sensorsArray = selectedDev.requestData.sensors_card_data
  //const sensorsArray = selectedDev?.requestData?.sensors_card_data.length === 0 ? [] : selectedDev.requestData.sensors_card_data

const tt = () => {
  if (sensorsArray?.length) {
    sensorsArray.map((v,i) => {
      //console.log(v.data_for_graph_today)
      return <TemperatureHumidityChart 
      data = {v.data_for_graph_today}
      />
    })
  } else return <></>
}

return <>

{ sensors_card_data.map((v,i) => {
  return <div key={'chart_' +i} className="container mt-5">
          <h2>Chart: sensor #{v.sensor_id}</h2>
          <TemperatureHumidityChart 
          data = {v.data_for_graph_today}
          />
        </div>
})

} 
</>

}

export default Charts
//test for data null Today